import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React, { useState } from 'react';
import { Button, Card, Col, Image, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import CreateSponsorNav from './create-sponsor-components/CreateSponsorNav';
import userConfig from 'assets/img/we-raise-images/user-cog.png';
import { weAddSponsorData } from 'data/weraise-data/donar-data';
import SelectBeneficiaryModal from './modals/SelectBeneficiaryModal';

const CreateNewSponsor = () => {
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <div className="py-0">
        <Row className="g-3">
          <Col md={4} lg={3}>
            <CreateSponsorNav />
          </Col>
          <Col md={8} lg={9}>
            <Card className="mb-3">
              <Card.Header>
                <IconButton
                  variant="default"
                  className="shadow-none text-primary"
                  iconClassName={'me-3'}
                  icon={'arrow-left'}
                  onClick={() => navigate(-1)}
                >
                  Back
                </IconButton>
              </Card.Header>
            </Card>
            <Card>
              <Card.Body>
                <Row className="overflow-auto g-3">
                  {weAddSponsorData?.map(data => (
                    <Col className="d-flex" lg={6} key={data.id}>
                      <Button
                        variant="default"
                        className="border p-3 rounded-3 text-start w-100 hover-border-primary"
                        onClick={() => setModalShow(true)}
                      >
                        <Flex alignItems="center">
                          <Image
                            src={userConfig}
                            className="me-3"
                            height={77}
                            width={77}
                          />
                          <div>
                            <p className="mb-1 fs-0 text-1100 fw-medium">
                              {data.title}
                            </p>
                            <p className="fs--1 mb-0 text-600">
                              {data.details}
                            </p>
                          </div>
                        </Flex>
                      </Button>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      <SelectBeneficiaryModal
        setModalShow={setModalShow}
        modalShow={modalShow}
        path="from"
      />
    </>
  );
};

export default CreateNewSponsor;
